import type { ReactElement } from 'react';
import SpaceY from '../../../components/SpaceY';
import { MAX_WIDTH_639PX } from '../../../utils/common';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';

interface Props {
  headerChildren: ReactElement;
  children: ReactElement | ReactElement[];
}
const MissionSectionWrapper = ({ headerChildren, children }: Props) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  return (
    <div className="">
      <hr className="border-brand-1" />

      <SpaceY height={isMobile ? 48 : 80} />
      {isMobile ? (
        <h3 className="text-left text-30px font-bold leading-[39px] text-brand-1">
          {headerChildren}
        </h3>
      ) : (
        <h2 className="text-center text-34px font-bold text-brand-1 sm:leading-[44.2px]">
          {headerChildren}
        </h2>
      )}

      <SpaceY height={isMobile ? 48 : 80} />
      {children}
    </div>
  );
};

export default MissionSectionWrapper;
